import React, { Component } from 'react'

export default class CostingHeading extends Component {
    render() {
        return (
            <div className='costing'>
                <h1>Costing</h1>
                <p>Transparent Pricing for Exceptional Services: Explore Our Costing Options</p>
            </div>
        )
    }
}
